import { observable, makeObservable } from 'mobx';
import { Model, IModelAttributes, attribute, entity } from 'Models/Model';
import * as Models from 'Models/Entities';

export interface IPointOfSaleProductEntityAttributes extends IModelAttributes {
	name: string;
	price: number;
	isDisabled?: boolean;
	priceOverrideCount?: number;
	priceOverrides: Array<
		Models.PointOfSaleProductPriceOverrideEntity | Models.IPointOfSaleProductPriceOverrideEntityAttributes
	>;
}

@entity('PointOfSaleProductEntity', 'PointOfSaleProduct')
export default class PointOfSaleProductEntity extends Model implements IPointOfSaleProductEntityAttributes {
	/**
	 * Fields to exclude from the JSON serialization in create operations.
	 */
	public static excludeFromCreate: string[] = [];

	/**
	 * Fields to exclude from the JSON serialization in update operations.
	 */
	public static excludeFromUpdate: string[] = [];

	@observable
	@attribute<PointOfSaleProductEntity, string>()
	public name: string;

	@observable
	@attribute<PointOfSaleProductEntity, number>()
	public price: number;

	@observable
	@attribute<PointOfSaleProductEntity, boolean>()
	public isDisabled?: boolean;

	@observable
	@attribute<PointOfSaleProductEntity, number>()
	public priceOverrideCount?: number;

	@observable
	@attribute({ isReference: true, manyReference: true })
	public priceOverrides: Models.PointOfSaleProductPriceOverrideEntity[] = [];

	constructor(attributes?: Partial<IPointOfSaleProductEntityAttributes>) {
		super(attributes);

		makeObservable(this);

		this.assignAttributes(attributes);
	}

	/**
	 * Assigns fields from a passed in JSON object to the fields in this model.
	 * Any reference objects that are passed in are converted to models if they are not already.
	 * This function is called from the constructor to assign the initial fields.
	 */
	public assignAttributes(attributes?: Partial<IPointOfSaleProductEntityAttributes>) {
		super.assignAttributes(attributes);

		if (attributes) {
			if (attributes.name !== undefined) {
				this.name = attributes.name;
			}
			if (attributes.price !== undefined) {
				this.price = attributes.price;
			}
			if (attributes.isDisabled !== undefined) {
				this.isDisabled = attributes.isDisabled;
			}
			if (attributes.priceOverrideCount !== undefined) {
				this.priceOverrideCount = attributes.priceOverrideCount;
			}
			if (attributes.priceOverrides !== undefined && attributes.priceOverrides !== null) {
				this.priceOverrides = attributes.priceOverrides.map(o =>
					o instanceof Models.PointOfSaleProductPriceOverrideEntity
						? o
						: new Models.PointOfSaleProductPriceOverrideEntity(o),
				);
			}
		}
	}

	/**
	 * Returns the string representation of this entity to display on the UI.
	 */
	public getDisplayName() {
		return this.name;
	}
}
